// Angular
import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
// models
import { DropdownOption } from 'src/app/models';

@Component({
    selector: 'app-field-horizontal-radio',
    templateUrl: './field-horizontal-radio.component.html',
    styleUrls: ['./field-horizontal-radio.component.scss'],
    standalone: false
})
export class FieldHorizontalRadioComponent<T> implements OnInit {
    @Input() model: any;
    @Input() options: DropdownOption<T>[];
    @Input() optionWidth: number;
    @Output() modelChange = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}
}
